/** Helpers for HTML email bodies written in the RichTextEditor. */

const TAGS =
  /<\/?(p|br|b|strong|i|em|u|s|span|h[1-6]|ul|ol|li|blockquote|table|tr|td|th|a|div)(\s[^>]*)?\/?>/i;

const escapeHtml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** Editor HTML for a body that may still be plain text (older templates and messages). */
export function toEditorHtml(body: string) {
  if (TAGS.test(body)) return body;
  return body
    .replace(/\r\n?/g, '\n')
    .split(/\n{2,}/)
    .map((p) => `<p>${escapeHtml(p).replace(/\n/g, '<br>')}</p>`)
    .join('');
}

/** The words of an HTML body (to tell an empty editor from one that says something). */
export function htmlText(html: string) {
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .trim();
}

/** Fills {placeholders} in an HTML template, escaping each value. */
export function fillHtml(template: string, values: Record<string, string | null | undefined>) {
  return toEditorHtml(template).replace(/\{(\w+)\}/g, (m, k: string) =>
    k in values ? escapeHtml(values[k] ?? '') : m,
  );
}

/** An HTML body as readable text with its line breaks (message lists). */
export function htmlToPlain(html: string) {
  if (!TAGS.test(html)) return html;
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|h[1-6]|blockquote|table)>/gi, '\n\n')
    .replace(/<\/(li|tr|div)>/gi, '\n')
    .replace(/<\/t[dh]>/gi, '  ')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
